import { Component, Input, SimpleChanges, OnChanges, OnInit, inject, DestroyRef } from '@angular/core';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { LtmsWidgetToolsComponent } from '../../../../ltms-widget-tools/ltms-widget-tools.component';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../ltms-loader/ltms-loader.component';
import { IndianNumberFormatPipe } from '../../../../../pipes/format-number/format-number.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'app-engagement-stackbar',
    templateUrl: './engagement-stackbar.component.html',
    styleUrl: './engagement-stackbar.component.scss',
    imports: [LtmsWidgetToolsComponent, NgIf, NgFor, NgClass, LtmsLoaderComponent, IndianNumberFormatPipe]
})
export class EngagementStackbarComponent implements OnInit, OnChanges {
  @Input() values: any;
  @Input() displayName: string = "";
  @Input() isDataLoaded: boolean = false;
  @Input() isDeviationEnabled = false;
  comparisonLabel = '';
  private destroyRef = inject(DestroyRef);
  stackContainersDetails: string = 'Visualize the Records Journey from receipt to response - highlighting conversions and drop-offs in the process.';
  recordsJourneyData: any = [];
  totalRecords: number = 0;
  isDataAvailable: boolean = false;

  widgetConfigbarGraph: any = {
    //TODO
    "download": {
      enable: true,
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": [],
        rows: [],
        columns: [
          {
            order: 1,
            header: "Request Metrics",
            dataKey: "key",
          },
          {
            order: 2,
            header: "Count",
            dataKey: "count"
          }
        ],
        title: "Records Journey",
        fileName: "Records Journey"
      }
    },
    "fullscreen": {
      enable: false,
      componentId: 'barChartId'
    }
  }

  constructor(
    private engagementService: EngagementService,
    private helpersService: HelpersService) {
  }

  ngOnInit(): void {
    this.helpersService.datePicker.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((datePicker: any) => {
      if (datePicker) {
        this.comparisonLabel = this.helpersService.getDeviationComparisonLabel(datePicker);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['values'] && changes['values'].currentValue) || changes['isDeviationEnabled']) {
      const data = changes['values']?.currentValue || this.values;
      if (data) {
        this.prepareStackedBarData(data);
      }
    }
  }

  prepareStackedBarData(data) {
    let currentData = (data && data.current) ? data.current : {};
    let previousData = (data && data.previous) ? data.previous : {};
    let rater_type: null | number = null;

    // TODO :- below code is commented and it should be enbled after helpers and brand detail section is done
    /* if (!isAccount) {
      rater_type = (Helpers.brandDetail && Helpers.brandDetail.main_rater_type) ? Helpers.brandDetail.main_rater_type : null;
    } else {
      rater_type = selected_rater_type;
    }
    Engagement.tableData = [];
    dateObject = {
      "current": "Count",
      "previous": "previous"
    } */
    rater_type = -1; // in above commented code rater type is to be assigned, so as of now assigning -1
    if (Object.keys(currentData).length) {

      // dateObject["current"] = (currentData.from_as_string && currentData.from_as_string != "") ? fromateDateString(currentData.from_as_string) : "Count";
      currentData.response_rate = this.engagementService.getResponeRate(currentData)
      currentData.response_score = this.engagementService.getResponseScore(currentData, rater_type)
      currentData.number_of_requests_received = this.engagementService.getRequestRecieved(currentData)
      currentData.number_of_requests_filtered = this.getRequestFiltered(currentData)

      if (Object.keys(previousData).length) {
        // dateObject["previous"] = (previousData.from_as_string && previousData.from_as_string != "") ? fromateDateString(previousData.from_as_string) : "Previous";
        previousData.response_rate = this.engagementService.getResponeRate(previousData);
        previousData.response_score = this.engagementService.getResponseScore(previousData, rater_type)
        previousData.number_of_requests_received = this.engagementService.getRequestRecieved(previousData)
        previousData.number_of_requests_filtered = this.getRequestFiltered(previousData)
      }
      this.recordsJourneyData = this.getTableData(currentData, previousData).map(item => ({
        ...item,
        deviation: this.isDeviationEnabled && Object.keys(previousData).length
          ? Helpers.getFieldDeviation(item.current, item.previous)
          : null
      }));

      this.totalRecords = this.recordsJourneyData.reduce((accumulator, currentValue, currentIndex) => {
        return accumulator + this.recordsJourneyData[currentIndex].current;
      }, 0);
      // Engagement.responseRate = getReponseRateTableData(currentData, previousData, rater_type)
      // Engagement.dataClone = EngagementService.clone(Engagement.tableData)
      /* if (Engagement.selectedField && Engagement.selectedField.length && Engagement.selectedField[0]) {
        var selectedData = Engagement.selectedField[0]
        var data = _.find(Engagement.tableData, function (field) {
          return selectedData.name == field.name
        })
        if (data) {
          Engagement.selectedField = [data];
          Engagement.selectedFieldDetails = data.fieldDetails;
          Engagement.tableData = _.reject(Engagement.tableData, function (object, index) {
            return (object.name == data.name)
          })
        } else {
          Engagement.selectedField = [];
          Engagement.selectedFieldDetails = [];
        }

      } */
        var test= this.recordsJourneyData.map(item => ({
          key: item.name,
          count: item.current.toString(),
        }));
      this.widgetConfigbarGraph['download']['data']['rows'] = this.recordsJourneyData.map(item => ({
        key: item.name,
        count: item.current.toString(),
      }));
      if (data && data.current && (data.current.doc_count != 0 || data.current.doc_count != '0')) {
        this.isDataAvailable = true;
      }

      const recordsReceivedIndex = this.widgetConfigbarGraph['download']['data']['rows'].findIndex(row => row.key === "Records Received");

      if (recordsReceivedIndex !== -1) {
        if (currentData) {
            interface Row {
                key: string;
                count: number;
            }

            let recordsReceivedViaMedium: Row[] = [
                {
                    key: "Only with Mobile no.",
                    count: currentData.request_received_with_phone_number || 0 // Set to 0 if not exists
                },
                {
                    key: "Only with Email ID",
                    count: currentData.request_received_with_email_address || 0 // Set to 0 if not exists
                },
                {
                    key: "With Mobile No. & Email ID",
                    count: currentData.request_received_with_phone_number_and_email_address || 0 // Set to 0 if not exists
                }
            ];

            this.widgetConfigbarGraph['download']['data']['rows'].splice(recordsReceivedIndex + 1, 0, ...recordsReceivedViaMedium);
          if (this.displayName && this.displayName.trim() != "") {
            this.widgetConfigbarGraph['download']['data']['title'] = "Records Journey - " + this.displayName;
          }
        }
      }
    }
  }

  getRequestFiltered(data) {
    return (data.number_of_requests_filtered || 0) + (data.number_of_unprocessed_records || 0) + (data.number_of_records_without_phone_number_and_email_address || 0) - (data.number_of_records_without_phone_number_email_address_and_filtered_data || 0)
  }

  getTableData(current, previous) {
    return [{
      "name": "Records Received",
      "current": (current && current.number_of_requests_received) ? current.number_of_requests_received : 0,
      "previous": (previous && previous.number_of_requests_received) ? previous.number_of_requests_received : 0,
      "difference": this.getDifference("number_of_requests_received", current, previous),
      "fontWeight": "bold",
      "click_disabled": true,
      // "percentage": (current.number_of_requests_received / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_requests_received / current.number_of_requests_received) * 100, 100) + "%"

    },
    {
      "name": "Records Filtered Out",
      "current": (current && current.number_of_requests_filtered) ? current.number_of_requests_filtered : 0,
      "previous": (previous && previous.number_of_requests_filtered) ? previous.number_of_requests_filtered : 0,
      "difference": this.getDifference("number_of_requests_filtered", current, previous),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.number_of_requests_filtered / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_requests_filtered / current.number_of_requests_received) * 100, 100) + "%"
    }, {
      "name": "Eligible Records",
      "current": (current.number_of_requests_all_attempts_failed || 0) + (current.number_of_unique_requests_sent || 0),
      "previous": (previous.number_of_requests_all_attempts_failed || 0) + (previous.number_of_unique_requests_sent || 0),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.number_of_unique_requests_sent / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_unique_requests_sent / current.number_of_requests_received) * 100, 100) + "%"
    }, {
      "name": "Records Failed",
      "current": (current && current.number_of_requests_all_attempts_failed) ? current.number_of_requests_all_attempts_failed : 0,
      "previous": (previous && previous.number_of_requests_all_attempts_failed) ? previous.number_of_requests_all_attempts_failed : 0,
      "difference": this.getDifference("number_of_requests_all_attempts_failed", current, previous),
      "click_disabled": true, 
      "fontWeight": "bold",
      // "percentage": (current.number_of_requests_all_attempts_failed / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_requests_all_attempts_failed / current.number_of_requests_receive) * 100, 100) + "%"
    }, {
      "name": "Records Sent",
      "current": (current && current.number_of_unique_requests_sent) ? current.number_of_unique_requests_sent : 0,
      "previous": (previous && previous.number_of_unique_requests_sent) ? previous.number_of_unique_requests_sent : 0,
      "difference": this.getDifference("number_of_unique_requests_sent", current, previous),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.number_of_unique_requests_sent / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_unique_requests_sent / current.number_of_requests_received) * 100, 100) + "%"
    }, {
      "name": "Records Undelivered",
      "current": (current && current.number_of_requests_undelivered) ? current.number_of_requests_undelivered : 0,
      "previous": (previous && previous.number_of_requests_undelivered) ? previous.number_of_requests_undelivered : 0,
      "difference": this.getDifference("number_of_requests_undelivered", current, previous),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.number_of_requests_undelivered / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_requests_undelivered / current.number_of_requests_received) * 100, 100) + "%"
    }, {
      "name": "Records Delivered",
      "current": (current && current.number_of_unique_requests_delivered) ? current.number_of_unique_requests_delivered : 0,
      "previous": (previous && previous.number_of_unique_requests_delivered) ? previous.number_of_unique_requests_delivered : 0,
      "difference": this.getDifference("number_of_unique_requests_delivered", current, previous),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.number_of_unique_requests_delivered / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_unique_requests_delivered / current.number_of_requests_received) * 100, 100) + "%"
    }
      , {
      "name": "Links Opened",
      "current": (current && current.feedback_link_open_count) ? current.feedback_link_open_count : 0,
      "previous": (previous && previous.feedback_link_open_count) ? previous.feedback_link_open_count : 0,
      "difference": this.getDifference("feedback_link_open_count", current, previous),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.feedback_link_open_count / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.feedback_link_open_count / current.number_of_requests_received) * 100, 100) + "%"

    },
    {
      "name": "Responses Received",
      "current": (current && current.number_of_request_generated_rated) ? current.number_of_request_generated_rated: 0,
      "previous": (previous && previous.number_of_request_generated_rated) ? previous.number_of_request_generated_rated: 0,
      "difference": this.getDifference("number_of_request_generated_rated", current, previous),
      "click_disabled": true,
      "fontWeight": "bold",
      // "percentage": (current.number_of_request_generated_rated   / current.number_of_requests_received) * 100 + "%"
      "percentage": Math.min((current.number_of_request_generated_rated / current.number_of_requests_received) * 100, 100) + "%"

    }
    ]
  }

  // calculate difference between current date range and previous date range data for given field.
  getDifference(field, current, previous) {
    var currentData = (current && this.engagementService.getProp(current, field)) ? this.engagementService.getProp(current, field) : 0;
    var previousData = (previous && this.engagementService.getProp(previous, field)) ? this.engagementService.getProp(previous, field) : 0;
    var diff = parseFloat((currentData - previousData).toFixed(1))
    return this.helpersService.getNumericValueToFormatedString(diff, 1)
  }
}
